import { createAction } from "@reduxjs/toolkit";
import { silentClient } from "../../../api-client.ts";
import { refreshTicketFiles } from "../../../files/store.ts";
import type { WorkOrderReportRequest } from "../../../generated-axios-client/index.ts";
import { type AppDispatch, listener, type RootState } from "../../../store.ts";
import { ticketActions } from "../../../../features/ticket/ticketSlice.ts";
import {
  downloadBlob,
  filenameFromContentDisposition,
} from "../../../../common/utils/downloadBlob.ts";

type CreateWorkOrderReportOptions = {
  ticketId: string;
  selection: WorkOrderReportRequest;
  fallbackFilename: string;
  onSuccess: () => void;
  onError: () => void;
};

export const createWorkOrderReport = createAction<CreateWorkOrderReportOptions>(
  "report/CREATE_WORK_ORDER_REPORT"
);

// The server saves the PDF to the work order's files and WO History while building
// it, so both are reloaded once the download has started.
listener.startListening.withTypes<RootState, AppDispatch>()({
  actionCreator: createWorkOrderReport,
  effect: async (action, { dispatch }) => {
    const { ticketId, selection, fallbackFilename, onSuccess, onError } = action.payload;
    // silent: the drawer shows its own error, as the shared toast cannot read a Blob body
    const response = await silentClient.apiV1ManagementReportsWorkOrderCreate(
      ticketId,
      selection,
      { responseType: "blob" }
    );
    if ("isAxiosError" in response) {
      onError();
      return;
    }
    downloadBlob(
      response.data as unknown as Blob,
      filenameFromContentDisposition(response.headers["content-disposition"]) ??
        fallbackFilename
    );
    onSuccess();
    await refreshTicketFiles(ticketId, dispatch);
    dispatch(ticketActions.refreshTicketHistory(ticketId));
  },
});
